import { DROPDOWN_LIST_PADDING, DROPDOWN_OPTION_PADDING_X, getDropdownGroupHeadingStyles, getDropdownOptionLabelStyles, getDropdownOptionStyles, getDropdownPaperStyles, getDropdownStatusStyles, getDropdownSurfaceActiveBackground, } from './dropdown-surface';
/** Theme name of the rich-text editor's `/` menu; the editor package names its slots with it. */
export const SLASH_COMMAND_MENU_THEME_NAME = 'OvSlashCommandMenu';
const SLASH_COMMAND_MENU_WIDTH = '21.5rem';
const ICON_TILE_SIZE = '1.375rem';
const ICON_GLYPH_SIZE = '0.875rem';
/** The `/` menu drawn as a SelectMenu: same card, rows, headings and icon tiles. */
export const getV2SlashCommandMenuStyleOverrides = () => ({
    paper: ({ theme }) => ({
        ...getDropdownPaperStyles(theme),
        minWidth: 0,
        width: SLASH_COMMAND_MENU_WIDTH,
        maxWidth: `calc(100vw - ${theme.spacing(3)})`,
    }),
    list: () => ({ padding: DROPDOWN_LIST_PADDING }),
    // The list scrolls inside a fixed-height card; a pinned heading would sit over the first rows.
    subheader: ({ theme }) => ({ ...getDropdownGroupHeadingStyles(theme), position: 'static' }),
    item: ({ theme }) => {
        const activeBackground = getDropdownSurfaceActiveBackground(theme);
        return {
            ...getDropdownOptionStyles(),
            alignItems: 'flex-start',
            '&:hover': { backgroundColor: 'transparent' },
            '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected.Mui-focusVisible': {
                backgroundColor: activeBackground,
            },
            '& .MuiListItemText-root': { margin: 0 },
            '& .MuiListItemText-primary': getDropdownOptionLabelStyles(theme),
            '& .MuiListItemText-secondary': {
                marginTop: '0.125rem',
                fontWeight: 400,
                fontSize: '0.71875rem',
                lineHeight: '1rem',
                color: theme.palette.custom.OV.sys.onSurfaceVariant,
            },
        };
    },
    itemIcon: ({ theme }) => ({
        marginRight: 0,
        marginTop: '0.0625rem',
        color: theme.palette.custom.OV.sys.onSurfaceVariant,
    }),
    iconBox: ({ theme }) => ({
        width: ICON_TILE_SIZE,
        height: ICON_TILE_SIZE,
        minWidth: 0,
        minHeight: 0,
        padding: 0,
        borderRadius: '0.375rem',
        backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
        '& svg': { width: ICON_GLYPH_SIZE, height: ICON_GLYPH_SIZE, fontSize: ICON_GLYPH_SIZE },
    }),
    prefixLabel: () => ({ fontSize: '0.5625rem', letterSpacing: 0 }),
    status: ({ theme }) => ({
        ...getDropdownStatusStyles(theme),
        '& .MuiTypography-root': { font: 'inherit', color: 'inherit' },
    }),
    divider: ({ theme }) => ({
        opacity: 1,
        borderColor: theme.palette.custom.OV.sys.outlineVariant,
        margin: `0.25rem ${DROPDOWN_OPTION_PADDING_X}`,
    }),
});
